import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import MainLayout from 'layouts/mainLayout'
import LoadingSpinner from 'components/Common/LoadingSpinner'
import api from 'api'
// import ICON_OPEN_IN_NEW_TAB from 'assets/icons/open_in_new.svg'
import './index.css'
import NavMain from '../../Nav/NavMain'
import eventBus from '../../../utils/eventBus'
import ZendeskLink from 'components/Common/ZendeskLink'

const BusinessResourceCenterCard = () => {
  // eslint-disable-next-line
  const [showOverlay, setShowOverlay] = useState(false)
  const [activeChipId, setActiveChipId] = useState('')
  const [solutions, setSolutions] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getPartnerSolutions = async () => {
      try {
        setLoading(true)
        const solutionRes = await api.getBusinessPartnerSolutions()
        setSolutions(solutionRes?.details || [])
      } catch (error) {
        console.error('error-getPartnerSolutions-', error)
      } finally {
        setLoading(false)
      }
    }
    getPartnerSolutions()
  }, [])

  const handleClick = async card => {
    const firstLogo = card?.logos?.[0] || {}
    api.businessSolutionsAudit(firstLogo.id)
    if (firstLogo.partnerLinkURL.includes('nav.com')) {
      eventBus.emit('navClick')
    } else if (firstLogo?.partnerLinkURL === '#') {
      return
    } else {
      window.open(firstLogo?.partnerLinkURL)
    }
  }

  // console.log('BRC-', { tabData })

  return (
    <MainLayout>
      <Box paddingY="30px" paddingX="30px" className="PartnerSolutions">
        <Box fontSize="34px" color="#25245F" fontWeight={600}>
          Partner  Integrations
        </Box>
        {loading ? (
          <div className="loading-wrapper">
            <LoadingSpinner />
          </div>
        ) : (
          <>
            <Box marginTop="30px" className="chip-wrapper">
              {solutions?.map(solution => {
                const scrollId = `solution${solution?.id}`
                return (
                  <div
                    className={`chip${solution?.id === activeChipId ? ' active' : ''}`}
                    key={solution?.id}
                    onClick={() => {
                      setActiveChipId(solution?.id)
                      document.getElementById(scrollId).scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'start',
                      })
                    }}
                  >
                    {solution?.title}
                  </div>
                )
              })}
            </Box>

            <Box marginTop="10px" className="solution-wrapper">
              {solutions?.map((solution, tabIndex) => {
                const scrollId = `solution${solution?.id}`
                return (
                  <React.Fragment key={solution?.id}>
                    <div className="solution-id" id={scrollId} />
                    <div className="solution-section" key={solution?.id}>
                      <div className="solution-name">{solution?.title}</div>
                      <div className="solution-description">{solution?.description}</div>
                      <div className="solution-card-wrapper">
                        {solution?.cards?.map(card => {
                          const firstLogo = card?.logos?.[0] || {}
                          return (
                            <div className="solution-card" onClick={() => handleClick(card)}>
                              <div className="card-title">{card?.title}</div>
                              <img className="card-image" src={firstLogo?.logoURL} alt="solution" />
                              <div className="card-description">{card?.description}</div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  </React.Fragment>
                )
              })}

              <ZendeskLink />
            </Box>
          </>
        )}
        <div style={{ display: 'none' }}>
          <NavMain />
        </div>
      </Box>
    </MainLayout>
  )
}

export default BusinessResourceCenterCard
